import Vue from 'vue';

import template from './credits.html';

Vue.component('credits', {
  template,
  props: [
    'animating',
  ],
  data: function () {
    return {
      showCredits: false,
    };
  },
  methods: {
    toggleCredits: function () {
      this.showCredits = !this.showCredits;
    }
  },
});



// WEBPACK FOOTER //
// ./src/components/credits/credits.js